import { useState } from 'react';

const useInputStatus = (validators, normalizer) => {
  const [value, setValue] = useState('');
  const [previousValue, setPreviousValue] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const changeHandler = (event) => {
    const current = event.target.value;
    const normalizedValue = normalizer ? normalizer(current, value) : current;
    event.preventDefault();

    setPreviousValue(value);
    setValue(normalizedValue);
    setErrorMsg(buildErrorMsg(normalizedValue));
    setIsTouched(true);
    event.target.value = normalizedValue;
  };

  const blurHandler = () => {
    setIsTouched(true);
    setErrorMsg(buildErrorMsg(value));
  };

  const buildErrorMsg = (valueToValidate) => {
    let message = '';
    validators.forEach((validator) => {
      message = `${message} ${validator(valueToValidate)}`;
    });
    return message.trim();
  };

  const reset = () => {
    setValue('');
    setIsTouched(false);
    setErrorMsg('');
    setPreviousValue('');
  };

  return {
    value,
    previousValue,
    errorMsg,
    hasError: errorMsg !== '' && isTouched,
    isTouched,
    changeHandler,
    blurHandler,
    reset,
  };
};

export default useInputStatus;
